import React from "react";
import { Link } from "react-router-dom";

const UslugeStupovi = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";

  return (
    <div className="intro-area pd-top-80">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center">
              <h2 className="title">
                Digitalni marketing <span>i</span> vanjsko oglašavanje
              </h2>
              <p>
                Dva ravnopravna kanala, jedna kampanja. Online vas klijenti
                pronađu — na ulici vas zapamte. SEO, Google Ads i društvene
                mreže rade rame uz rame s billboardima, wallscapeom i city
                lightovima diljem Hrvatske.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="channel-visual-card">
              <div className="channel-visual-thumb">
                <img
                  src={publicUrl + "assets/img/card-digital.png"}
                  alt="Digitalni marketing — laptop, oglasi i analitika"
                />
              </div>
              <div className="channel-visual-body">
                <h4 className="intro-title">Digitalni marketing</h4>
                <p>
                  SEO optimizacija, Google Ads, vođenje društvenih mreža, izrada
                  web stranica i content marketing. Mjerljive kampanje: tko vas
                  vidi, što klikne i koliko košta svaki upit.
                </p>
                <Link
                  className="btn btn-yellow"
                  to="/digitalni-marketing"
                  style={{ marginTop: "22px" }}
                >
                  Digitalne usluge
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="channel-visual-card">
              <div className="channel-visual-thumb">
                <img
                  src={publicUrl + "assets/img/card-outdoor.png"}
                  alt="Vanjsko oglašavanje — billboardi i city lightovi"
                />
              </div>
              <div className="channel-visual-body">
                <h4 className="intro-title">Vanjsko oglašavanje</h4>
                <p>
                  Billboardi, bigboardi, wallscape, city lightovi, putokazi i
                  nadvožnjaci — 500+ oglasnih površina na najprometnijim
                  lokacijama, od Splita i Dalmacije do cijele Hrvatske.
                </p>
                <Link
                  className="btn btn-yellow"
                  to="/oglasne-povrsine"
                  style={{ marginTop: "22px" }}
                >
                  Oglasne površine
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UslugeStupovi;
